import React, {useId, useState} from 'react'

type Props = {
  title: string
  description: string
  icon: string
  badge: React.ReactNode
  initiallyOpen?: boolean
  children: React.ReactNode
}

const PanelListSection = ({
  title,
  description,
  icon,
  badge,
  initiallyOpen = false,
  children,
}: Props) => {
  const [open, setOpen] = useState(initiallyOpen)
  const contentId = useId()

  return (
    <section className='card border shadow-sm mb-5' aria-label={title}>
      <button
        type='button'
        className='btn text-start p-5 p-lg-6 w-100'
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => setOpen((value) => !value)}
      >
        <span className='d-flex align-items-center gap-4'>
          <span className='bg-light-primary rounded p-3 d-inline-flex'>
            <i className={`bi ${icon} text-primary fs-2`} aria-hidden='true' />
          </span>
          <span className='flex-grow-1'>
            <span className='d-flex flex-wrap align-items-center gap-3 mb-1'>
              <span className='fw-bold fs-4 text-gray-900'>{title}</span>
              {badge}
            </span>
            <span className='d-block text-muted fs-7 fw-normal'>{description}</span>
          </span>
          <i
            className={`bi bi-chevron-${open ? 'up' : 'down'} text-gray-600 fs-5`}
            aria-hidden='true'
          />
        </span>
      </button>
      <div id={contentId} hidden={!open} className='border-top p-5 p-lg-6'>
        {children}
      </div>
    </section>
  )
}

export default PanelListSection
